import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";

import FilterComponent from "../../../../../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedCampaigns,
  setSelectedKeyword,
  setSelectedAdgroups,
} from "../../../../../../../../features/aiRecomendationTabSlice";
import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSearchParams } from "react-router-dom";

export default function StAiRecFilterCard() {
  const {
    selectedCampaigns,
    selectedAdgroups,
    selectedKeyword,
    allAIRecomendation,
  } = useSelector((state: any) => state.aiRecomandationTab);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const filterConfig = [
    {
      key: "campaign_name",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaigns,
      filterName: "campaign_name",
      data: allAIRecomendation,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCampaigns(updatedSelection)),
      count: selectedCampaigns && selectedCampaigns.length,
      colorSelected:
        selectedCampaigns !== null && selectedCampaigns.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "adgroup_name",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdgroups,
      filterName: "adgroup_name",
      data: allAIRecomendation,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAdgroups(updatedSelection)),
      count: selectedAdgroups && selectedAdgroups.length,
      colorSelected:
        selectedAdgroups !== null && selectedAdgroups.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    setSearchAdgroups("");
    setSearchCampaigns("");
    dispatch(setSelectedCampaigns([]));
    dispatch(setSelectedAdgroups([]));
    dispatch(setSelectedKeyword(""));
  };

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    dispatch(setSelectedKeyword(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      data-tracker="136"
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 2, // adjust spacing as needed
      }}
    >
      <Autocomplete
        fullWidth
        disablePortal
        data-tracker="136"
        sx={{ width: "390px" }}
        options={allAIRecomendation.map((opt: any) => opt.keyword_name)}
        value={selectedKeyword || []}
        onChange={(_, newValue: string | null) => {
          dispatch(setSelectedKeyword(newValue ?? ""));
          setSearchParams((prevParams) => {
            const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
            if (newValue) {
              updatedParams.search = newValue; // Set new value
              updatedParams.page = "0";
            } else {
              delete updatedParams.search; // Remove from URL if cleared
            }
            return updatedParams;
          });
        }}
        getOptionLabel={(opt) => opt || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Keyword"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ marginLeft: "12px" }} />
                </InputAdornment>
              ),
            }}
            data-tracker="605"
            color="secondary"
          />
        )}
        size="small"
      />
      <Box data-tracker="606" sx={{ position: "relative" }}>
        <FilterComponent
          filterConfig={filterConfig}
          clearFilters={clearFilters}
        />
      </Box>
    </Box>
  );
}
